export default "__VITE_PUBLIC_ASSET__eaab9b95__"